/**
 * informeApi — el informe de liquidación que se le manda a la compañía.
 *
 *   GET /api/informe?tipo=dia&fecha=YYYY-MM-DD[&compania=<uuid>]
 *   GET /api/informe?tipo=mes&period=YYYY-MM[&compania=<uuid>]
 *
 * SÓLO LECTURA. El documento presenta lo que ya pasó; todo lo que se ejecuta del ciclo
 * vive en `diaApi.js`.
 *
 * Mismo patrón que mesApi.js: JWT de staff Clerk, URL vía baseUrl.js (same-origin → proxy
 * api/yoolpay/api/[endpoint].js), y el error se lanza como `Error(mensaje)`.
 *
 * @see src/pages/payments/yoolpay/InformeLiquidacion.jsx — único consumidor
 * @see src/services/yoolpay/mesApi.js — el calendario del mes
 */
import { yoolpayBaseUrl } from './baseUrl.js';

const BASE = yoolpayBaseUrl();

/**
 * El informe de un día o de un mes.
 *
 * `tipo` y su parámetro de período son OBLIGATORIOS y payment responde 400 si faltan: un
 * default silencioso emitiría un documento que nadie pidió, y en un papel que se le manda
 * a un tercero eso es peor que un error.
 *
 * Sin `compania` vuelven todas las que tuvieron movimiento en el período.
 */
export async function getInforme(token, { tipo, fecha, period, compania } = {}) {
  const params = new URLSearchParams({ tipo: tipo ?? '' });
  if (tipo === 'dia') params.set('fecha', fecha ?? '');
  if (tipo === 'mes') params.set('period', period ?? '');
  if (compania) params.set('compania', compania);

  const res = await fetch(`${BASE}/api/informe?${params.toString()}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload?.error || `payment respondió ${res.status}`);
  return payload;
}
